import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import AlertTypeForm from '../components/AlertTypeForm';
import * as alertTypeActions from '../redux/modules/alertTypes';
import * as accountActions from '../redux/modules/accounts';
import i18n from '../translations/i18n';

const propTypes = {
  params: PropTypes.any,
  t: PropTypes.func,
  fetchAlertType: PropTypes.func,
  fetchAccounts: PropTypes.func,
  unloadCurrent: PropTypes.func,
  modifyAlertType: PropTypes.any,
  alertType: PropTypes.any,
  accounts: PropTypes.any,
  currentUser: PropTypes.any,
};

class AlertTypeModify extends React.Component {
  constructor(props) {
    super(props);

    // @TODO add validation
    const id = props.params.splat;
    this.props.fetchAlertType(id);
    this.props.fetchAccounts();
    this.onModifyAlertType = this.onModifyAlertType.bind(this);
  }

  componentWillUnmount() {
    this.props.unloadCurrent();
  }

  onModifyAlertType(values) {
    this.props.modifyAlertType(values);
  }

  render() {
    const { alertType, accounts } = this.props;

    let accountsArray = [];

    if (accounts) {
      accountsArray = Object.values(this.props.accounts);
    }

    const disableSave = !(this.props.currentUser && this.props.currentUser.role === 'SUPER_ADMIN');

    return (
      <PageBase title={this.props.t('modify_alert_type')}>
        <AlertTypeForm
          alertType={alertType}
          onSubmit={this.onModifyAlertType}
          isModify
          disableSave={disableSave}
          initialValues={alertType}
          accounts={accountsArray}
        />
      </PageBase>
    );
  }
}

function mapStateToProps(state) {
  return {
    alertType: state.alertTypes.current,
    accounts: state.accounts.entities,
    currentUser: state.auth.current,
  };
}

AlertTypeModify.propTypes = propTypes;

const actions = Object.assign({}, accountActions, alertTypeActions);

const extended = translate(['translations'], { i18n })(AlertTypeModify);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AlertTypeModify.js